import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Services from '../components/Services';
import Realisations from '../components/Realisations';
import Blog from '../components/Blog';
import Testimonials from '../components/Testimonials';
import Footer from '../components/Footer';
import ScrollToTop from '../components/ScrollToTop';

function HomePage() {
  return (
    <div className="home-page">
      <Header />
      <Hero />
      <Services />
      <Realisations />
      <Blog />
      <Testimonials />
      <Footer />
      <ScrollToTop />
    </div>
  );
}

export default HomePage;

